<template>
    <transition name="el-fade-in">
        <div v-show="toTopShow">
          <div class="linear-bg page-up" @click="scrollToTop">
            <img src="~imgs/top.png" alt="">
          </div>
          <div class="fix-nav" v-show="$route.path ==='/'">
            <ul class="container-bubble-wrapper fixed-nav">
              <li class="container-bubble" :class="{active: activeIndex === index}" 
                v-for="(item,index) of containers" 
                :key="item" 
                @click="handleScrollToContainer(item, index)">
                <!-- {{bubbles && bubbles[index] && bubbles[index].name}} -->
                <span class="fixed-font">{{item}}</span><span class="circle"></span>
              </li>
            </ul>
          </div>
        </div>
    </transition>
</template>

<script>
    export default {
        data () {
            return {
                toTopShow: false,
                scrollTop: 0,
                activeIndex: 0,
                containers: ['戏曲剧种', '经典剧目', '音乐表演', '舞台美术', '剧团机构', '戏曲杂记', '演出习俗'],
                contentId: ['xqjz', 'jdjm', 'yyby', 'wtms', 'jtjg', 'xqzj', 'ycxs'],
                heights: []
            }
        },
        mounted () {
            this.$nextTick(function () {
                window.addEventListener('scroll', this.handleScroll, true);
            });
        },
        destroyed () {
            window.addEventListener('scroll', this.handleScroll, true);
        },
        methods: {
            handleScroll () {
                this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                if (this.scrollTop > 450) {
                    this.toTopShow = true;
                    this.activeIndex = 0;
                    if(  this.scrollTop > 750) {
                       this.activeIndex = 1;
                    }
                    if( this.scrollTop > 1300) {
                       this.activeIndex = 2;
                    }
                    if( this.scrollTop > 1800) {
                       this.activeIndex = 3;
                    }
                    if( this.scrollTop > 2300) {
                       this.activeIndex = 4;
                    }
                    if( this.scrollTop > 2700) {
                       this.activeIndex = 5;
                    }
                    if( this.scrollTop > 3200) {
                       this.activeIndex = 6;
                    }
                } else {
                    this.toTopShow = false;
                }
            },
            scrollToTop() {
                let timer = null;
                let _this = this;
                cancelAnimationFrame(timer);
                timer = requestAnimationFrame(function fn() {
                    if (_this.scrollTop > 5000) {
                        _this.scrollTop -= 1000;
                        window.scrollTo(0, _this.scrollTop);
                        timer = requestAnimationFrame(fn);
                    } else if (_this.scrollTop > 1000 && _this.scrollTop <= 5000) {
                        _this.scrollTop -= 500;
                        window.scrollTo(0, _this.scrollTop);
                        timer = requestAnimationFrame(fn);
                    } else if (_this.scrollTop > 200 && _this.scrollTop <= 1000) {
                        _this.scrollTop -= 100;
                        window.scrollTo(0, _this.scrollTop);
                        timer = requestAnimationFrame(fn);
                    } else if (_this.scrollTop > 50 && _this.scrollTop <= 200) {
                        _this.scrollTop -= 10;
                        window.scrollTo(0, _this.scrollTop);
                        timer = requestAnimationFrame(fn);
                    } else if (_this.scrollTop > 0 && _this.scrollTop <= 50) {
                        _this.scrollTop -= 5;
                        window.scrollTo(0, _this.scrollTop);
                        timer = requestAnimationFrame(fn);
                    } else {
                        cancelAnimationFrame(timer);
                        _this.toTopShow = false;
                    }
                });
            },
            handleScrollToContainer(item, index) {
              this.activeIndex = index;
              document.getElementById(this.contentId[index]).scrollIntoView();
            },
        }
    }
</script>

<style scoped lang="less">
  .page-up {
    position: fixed;
    right: 0;
    bottom: 0;
    padding-right: 100px;
    padding-bottom: 100px;
  }
  .fix-nav {
    position:fixed;
    top:168px;
    right:calc(50vw - 740px);
    transform:translateY(-50%);
    ul{
      .active{//13*13 border 4
          font-size: 16px;
          color: #a31f24;
        .circle{
          position: relative;
          left: -5px;
          width: 13px;
          height: 13px;
          border-radius: 50%;
          border: 3px solid #a31f24;
          background-color: #e1baba;
        }
      }
      li{
        margin: 24px 0px;
        font-size: 15px;
        color: #94491f;
        .circle{
          margin: 0 4px 0 16px;
          width: 11px;
          height: 11px;
          border-radius: 50%;
          border: 3px solid #dbcfc8;
          background: #ffffff;
          display: inline-block;
          -moz-border-radius: 50%; /* Firefox */
          -webkit-border-radius: 50%; /* Safari 和 Chrome */
          border-radius: 50%; /* Opera 10.5+, 以及使用了IE-CSS3的IE浏览器 */
        }
      }
      &::after{
        position: absolute;
        top: -20px;
        right: 18px;
        content: "";
        height: 330px;
        border: 0.5px solid #cccccc;
        z-index: -1;
      }
    }
  }

@media screen and (max-width: 1530px) {
  .fix-nav{
    right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/common/scrollTop.vue